import axios from "axios";
import Router from './../../router'
import { setActivePinia } from "pinia";
import { isLooseDeepEqual } from "../../helpers/General";
import { useCurrentUserStore } from "../../pinia/CurrentUserStore";
import { ConsoleLog } from "@openreplay/tracker/lib/app/messages.gen";

const state = () => ({
    tabs: [],
    loaded_for: 0,
    debounce: null,
})

const getters = {
}

const actions = {
    async closeTab({ commit, state, rootState }, data) {
        if(state.debounce){
            commit("clearDebounce");
        }
        commit("closeTab", data.tab);
        commit("setDebounce", setTimeout(async () => {
        await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/closeTab", { tab: state.tabs }).then((response) => {
            if (response.data.tabs !== undefined) {

                commit("setTabs", response.data.tabs);

                if (data.tab.active == true) {
                    var closedId = data.tab.id;
                    var nextId = parseInt(closedId) + 1;
                    commit("setTabActiveById", nextId);
                }

                axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/storeTabs", { tabs: state.tabs }).then((response) => {
                })

            }
        })
        }, 500) )
    },
    async storeTabs({ commit, state, rootState }, data) {
            await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/storeTabs", { tabs: state.tabs }).then((response) => { })
    },
    async internalTabs({ commit, state, rootState }, data) {
        if (rootState.settings.internal.user_company == state.loaded_for) {
            return;
        }
        await axios.get(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/internalTabs", {}).then((response) => {
            if (response.data.tabs !== undefined) {
                commit("setTabs", response.data.tabs, rootState.settings.internal.user_company);
            } else {
                commit("setTabs", []);
            }
        })
    }
}

const mutations = {
    setDebounce(state,timeout){
        state.debounce = timeout;
    },
    clearDebounce(state){
        clearTimeout(state.debounce)
    },
    closeTab(state, payload) {
        var index = state.tabs.findIndex(item => item.id == payload.id);
        if (index >= 0) {
            state.tabs.splice(index, 1);
        }
    },
    setTabs(state, tabs, company_id) {
        if (tabs && tabs != undefined) {
            state.tabs = tabs;
        }
        state.loaded_for = company_id;
    },
    unshiftTabs(state, tabs) {
        for (const i in tabs) {
            state.tabs.unshift(tabs[i]);
        }
    },
    updateTabWithIndex(state, payload){
        state.tabs[payload.index] = JSON.parse(JSON.stringify(payload.tab));

    },
    updateTab(state, payload) {
        var index = state.tabs.findIndex(item => item.id == payload.id);
        if (index >= 0) {
            state.tabs[index] = payload;
            this.dispatch("browserTabs/storeTabs", { tabs: state.tabs });
        }
    },
    addTab(state, payload) {
        const userStore = useCurrentUserStore();
        let max_tabs = parseInt(userStore.user?.profile?.defaults?.max_tabs ?? 20);

        var nextMaxId = -1;
        for (const i in state.tabs) {
            if (state.tabs[i].id > nextMaxId) {
                nextMaxId = state.tabs[i].id;
            }
        }

        if (nextMaxId == -1) {
            nextMaxId = 0;
        } else {
            nextMaxId++;
        }

        var duplicateIdentifier = null;

        var tab = {
            id: nextMaxId,
            name: payload.route.name,
            params: payload.route.params,
            title: payload.route.title,
            duplicateIdentifier: payload.route.duplicateIdentifier,
        };

        const router = payload.router;
        if (state.tabs) {
            var index = state.tabs.findIndex(item =>{
                try{
                    return router.resolve({
                        name: item.name,
                        params: item.params
                    }).href == router.resolve({
                        name: payload.route.name,
                        params: payload.route.params
                    }).href
                }catch(error) {
                    return  isLooseDeepEqual({name: item.name, params: item.params}, {name : payload.route.name, params: payload.route.params})
                }
        })
        } else {
            index = -1;
        }

        if (index <= -1) {
            if (state.tabs.length >= max_tabs) {
                state.tabs.splice(0, 1);
            }
            this.commit("browserTabs/addTabToState", {
                tab: tab,
                triggerRedirect: payload.triggerRedirect,
            });
        } else {
            this.commit("browserTabs/updateTabWithIndex", {tab: tab,index:  index});
            this.commit("browserTabs/setTabActive", { tab: tab });
        }
        this.dispatch("browserTabs/storeTabs", { tabs: state.tabs });


    },
    addTabToState(state, payload) {
        state.tabs.push(payload.tab);
        this.commit("browserTabs/setTabActive", {
            tab: payload.tab,
            triggerRedirect: payload.triggerRedirect,
        });
    },
    setTabActive(state, payload) {
        var clickedTab = payload.tab;

            if (payload.triggerRedirect) {
                Router.push({ name: clickedTab.name, params: clickedTab.params });
            }
    },
    setTabActiveById(state, id) {
        var found = false;
        for (const i in state.tabs) {
            if (state.tabs[i].id == id) {
                state.tabs[i].active = true;
                found = true;
            } else {
                state.tabs[i].active = false;
            }
        }

        if (!found) {
            if (state.tabs[0] !== undefined) {
                state.tabs[0].active = true;
            }
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
}
